import * as Yup from "yup";

export const responsablesFormValidation = Yup.object({
  responsableDeDatos: Yup.string().required("Campo obligatorio").nullable(),
});

export const validateRequiredFields = (values, model) => {
  const errors = {};
  const errorMessage = "Campo obligatorio";

  for (var value in values) {
    //valida que el campo exista en los datos de la nomina para validar su obligatoriedad
    if (model[value]) {
      if (model[value].obligatorio && !values[value]) {
        errors[value] = errorMessage;
      }
    }
  }

  return errors;
};
